import { LocDefs, LocMap } from '@cm/core/localization';
import { pathStart, sharedProperties } from '../../models/score-report-delay-locs';

export type SPSettingsScoreReportDelayDefaultLocNames =
	| 'SPSettingsScoreReportDelayDefaultTitle'
	| 'SPSettingsScoreReportDelayDefaultEditButton'
	| 'SPSettingsScoreReportDelaySettingsNoSettingsMessage';

export const spSettingsScoreReportDelayDefaultLocs: LocDefs<SPSettingsScoreReportDelayDefaultLocNames> =
	{
		SPSettingsScoreReportDelayDefaultTitle: {
			defaultValue: 'Default Exam Score Report Settings',
			description: 'Section title for the default settings.',
			displayPath: `${pathStart}Default Settings|Section Title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPSettingsScoreReportDelayDefaultEditButton: {
			defaultValue: 'Edit',
			description: 'Button to edit the default settings.',
			displayPath: `${pathStart}Default Settings|Edit Button`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsNoSettingsMessage: {
			defaultValue: 'No settings found.',
			description: 'Message to display when there are no settings.',
			displayPath: `${pathStart}Delay Settings|No Settings Message`,
			displayType: 'Content',
			...sharedProperties,
		},
	};

export type SPSettingsScoreReportDelayDefaultLocType =
	LocMap<SPSettingsScoreReportDelayDefaultLocNames>;
